import { Response } from 'lib-shared-legacy-types';

import { ajaxSend } from 'api/api';
import { ChatBot } from 'apis/chatbots';

const v1Path = '/v1/chatbots';

type GetAgentOptions = {
  path?: string;
};

export function getChatBots({
  path = v1Path,
}: GetAgentOptions): Promise<Response<ChatBot[]>> {
  return ajaxSend<ChatBot[]>({ path }, true).then((res) => ({
    data: res.data,
    meta: {
      next_page: null,
      prev_page: null,
    },
  }));
}
